import React, {PropTypes} from 'react';

export default function Page({pageClassName, children}) {
  return (
    <div className={`page ${pageClassName}`}>
      {children}
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  pageClassName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/layout/components/Page.js